import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

/** True if the current page is being served from the Emergent preview environment. */
export function isPreviewEnv() {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname || "";
  return h.endsWith(".preview.emergentagent.com");
}

// Paths that are still allowed on preview — auth flow, admin backup, draft previews.
const PREVIEW_WRITE_ALLOWLIST = [
  /^\/auth\//,
  /^\/admin\/backup/,
  /^\/waybills\/preview/,   // draft PDF preview (does not persist)
];

// On preview: block any write that's not in the allowlist, so the team can't
// accidentally enter live data into the wrong environment.
api.interceptors.request.use((config) => {
  if (!isPreviewEnv()) return config;
  const method = (config.method || "get").toLowerCase();
  if (method === "get" || method === "head" || method === "options") return config;
  const url = config.url || "";
  if (PREVIEW_WRITE_ALLOWLIST.some((re) => re.test(url))) return config;
  // Cancel the request with a clear error the UI already surfaces in toasts.
  const err = new Error("Data entry is disabled on the development preview. Use https://inspection.portside.nl instead.");
  err.response = {
    status: 423,
    data: { detail: "Preview is read-only — switch to the live app at https://inspection.portside.nl" },
  };
  return Promise.reject(err);
});
